import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    components: {
        "FontAwesomeIcon": FontAwesomeIcon,
    },

    methods: {
        /* Called through the global, not stored here. `main.js` replaces
           `route` with the locale-aware wrapper after this module loads, and a
           captured reference would keep building unprefixed URLs. */
        route(name, params, absolute, config) {
            return route(name, params, absolute, config);
        },
    },
}
